module.exports = __webpack_public_path__ + "1201b0f531293e17d9399b631a86c04d.jpg";